/**
 * A string that has been localized
 */
export type LocalizedStringBrand = string & {
    readonly LocalizedString: unique symbol;
};

export type LocalizedString = string & LocalizedStringBrand;

export const createLocalizedString = (value: string): LocalizedString => {
    return value as LocalizedString;
};

/**
 * @internal
 */
export function unsafeLocalizedString(n: number | string): LocalizedString {
    return String(n) as any;
}

type ReactChild = React.ReactElement<unknown> | LocalizedString;

export interface ChildrenArray extends Array<Children> {}
export type ReactFragment = ChildrenArray;
export type Children = ReactChild | ReactFragment | boolean | null | undefined;

export const intercalateChildren = (sep: Children, arr: Array<Children>) => {
    const filteredArr = arr.filter(a => a != null && a !== false);

    return filteredArr.reduce<Children[]>((acc, curr, index) => {
        if (index > 0) {
            acc.push(sep);
        }
        acc.push(curr);
        return acc;
    }, []);
};